<template>
  <div class="Analytics">
  </div>
</template>

<script>
import Settings from '@/config/Settings'

export default {
  name: 'Analytics',
  watch: {
    '$route'() {
      this.track({ name: 'parlement', pageview: this.$route.path })
    }
  },
  mounted() {
    document.body.classList.add('Parlement')
    console.log(window.load_framework)
    window.load_framework.init({
      currentProjectId: 117,
      base_url: {
        fr: Settings.onfWebsite.fr + '/web',
        en: Settings.onfWebsite.en + '/web'
      }
    })
    setTimeout(() => {
      this.track({ name: 'begin', event: 'auto_begin' })
    }, 1000 * 10)
  },
  methods: {
    track(infos) {
      _.each(Settings.ua_code, code => {
        const o = {
          language: this.lang,
          ua_code: code,
          ...infos
        }
        if(window.google_analytics)
          window.google_analytics.gaTrack(o)
      })
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

body.Parlement
  #interactive-header
    display none

.Analytics
  display none
</style>
